var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultBankLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3707_17164)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3707_17164)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 34.5487C28.0328 34.5487 34.545 28.0365 34.545 20.0032C34.545 11.97 28.0328 5.45776 19.9996 5.45776C11.9663 5.45776 5.4541 11.97 5.4541 20.0032C5.4541 28.0365 11.9663 34.5487 19.9996 34.5487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5273 18.3321L27.4724 18.3321C28.3225 18.3321 28.6563 17.2059 27.949 16.7243L20.953 11.9602C20.3758 11.5672 19.6239 11.5672 19.0467 11.9602L12.0507 16.7243C11.3434 17.2059 11.6772 18.3321 12.5273 18.3321Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18.3321,
    width: 3.33333,
    height: 6.66667,
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6665,
    y: 18.3321,
    width: 3.33333,
    height: 6.66667,
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.1516 24.9988C26.4672 24.9988 26.7558 25.1771 26.8969 25.4594L27.7303 27.1261C28.0073 27.6802 27.6044 28.3321 26.9849 28.3321L13.015 28.3321C12.3955 28.3321 11.9926 27.6802 12.2696 27.1261L13.103 25.4594C13.2441 25.1771 13.5327 24.9988 13.8483 24.9988L26.1516 24.9988Z",
    fill: "#00535C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3707_17164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3707_17164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBankLogo);
export default __webpack_public_path__ + "static/media/default-bank-logo.ef70e20e.svg";
export { ForwardRef as ReactComponent };